import { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { Langs } from '@/components';
import { global } from '@/modules';
import styles from './Menu.module.less';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MenuProps } from '@/routes/type';
import { has, includes, cloneDeep } from 'lodash';
const { Sider } = Layout;

type SliderMenuType = {
  items: MenuProps[];
};

export const SliderMenu = ({ items }: SliderMenuType) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const pathArr = ['/create'];
  const appInfo = useSelector(global.selector.getAppInfo);
  const type = appInfo?.type;
  const menu: any = useMemo(() => {
    function filterMenu(tree: MenuProps[]) {
      const data = [];
      for (let i = 0; i < tree.length; i++) {
        const item: any = tree[i];

        item.key = item['path'] as string;

        item.label = t(`develop_prefix_${item['name']}`);

        if (has(item, 'role') && !includes(item.role, type)) {
          tree.splice(i--, 1);
        } else {
          if (item.children) {
            item.children = filterMenu(item.children);
          }
          data.push(item);
        }
      }
      return data;
    }

    return filterMenu(cloneDeep(items));
  }, [items, type, t]);

  const selectPath = location.pathname == '/create' ? '/' : '';
  return (
    <div className={styles.container}>
      <Sider width={272}>
        {pathArr.includes(location.pathname) || location.pathname.includes('app') ? (
          <div
            className={styles.back_app}
            onClick={() => {
              navigate('/');
            }}
          >
            <div className={styles.back_icon}>
              <span className="material-symbols-rounded">arrow_back_ios</span>
            </div>
            <Langs title="back_app" />
          </div>
        ) : null}
        <Menu
          mode="inline"
          selectedKeys={[`${location.pathname}`, selectPath]}
          style={{ borderRight: 0 }}
          items={menu}
          defaultOpenKeys={['/app']}
          onClick={(e: any) => {
            const { key } = e;
            if (key == '') {
              return;
            }
            navigate(key);
          }}
        />
      </Sider>
    </div>
  );
};
